<template>
    <div class="el-tooltip el-tiptap-editor__command-button"  @click="toEdit">
        <el-tooltip 
                class="item" 
                effect="dark" 
                :content="$t('titleEditor.SeniorEditor')" 
                placement="top"
            >
            <i class="el-icon-edit-outline" ></i>
        </el-tooltip>

        <el-dialog
            class="advanced-editor"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="$t('titleEditor.SeniorEditor')"
            :append-to-body="true"
            :visible.sync="dialogVisible">
            <el-tiptap
                v-model="htmlContent"
                :extensions="extensions"
                :placeholder="`${$t('main.PleaseEnterContent')} …`"
            >
            </el-tiptap>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="cancel">{{$t('main.cancel2')}}</el-button>
                <el-button size="small" type="primary" @click="onClick">{{$t('main.ok2')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex"
import SuperscriptMark from '../superscript/superscriptMark'
import SubscriptMark from '../subscript/subscriptMark'
import ClearFormat from '../clearFormat/clearFormat.js'
import {
    // 需要的 extensions
  Doc,
  Text,
  Paragraph,
  Heading,
  Bold,
  TextColor,
  Underline,
  Italic,
  Strike,
  ListItem,
  FontSize,
  Image,
  Blockquote,
  BulletList, // use with ListItem
  OrderedList, // use with ListItem
  TodoItem,
  TodoList, // use with TodoItem
  TextAlign,
  Indent,
  HorizontalRule,
  HardBreak,
  History,
  Fullscreen,
//   CodeView
} from "element-tiptap"
import $ from 'jquery'
export default {
    // 自定义高级编辑组件
    name: "advancedEditingBtn",
    // props: {
    //     id: String,    // 接受父组件传递的值
    // },
    data() {
        return {
            dialogVisible: false,
            htmlContent: '',
            extensions: [],
        }
    },
    computed:{
        ...mapState(['htmlEditor', 'headers']),
        id(){
            let id
            if (sessionStorage.getItem('examId')) {
                id = sessionStorage.getItem('examId')
            } else if (sessionStorage.getItem('wid')) {
                id = sessionStorage.getItem('wid')
            }
            return id
        },
    },
    watch: {
        htmlEditor(newV) {
            this.htmlContent = newV
            // console.log(this.htmlContent)
        }
    },
    created() {
        this.htmlContent = this.htmlEditor
        // console.log(this.htmlContent)
        this.extensions = [
            new Doc(),
            new Text(),
            new Paragraph(),
            new FontSize(),
            new Heading({ level: 5}),
            new Bold(),
            new TextColor(
                {
                    colors: ['#fff','#000000', '#fe0000',
                '#ff9900', '#feff00', '#98fa1b', '#6dddff', '#413ed6', '#ee41fd'
                ],
                menubar: true
                }
            ),
            new Underline(),
            new Italic(),
            new Strike(),
            new ListItem(),
            new SuperscriptMark(),
            new SubscriptMark(),
            new Image({ urlPattern: '', 
                uploadRequest: (file) => {
                    return new Promise(async resolve => {
                        var formData = new FormData()
                        formData.append('file', file)
                        formData.append('biz', 'upDataWj')
                        $.ajax({
                            url: `${this.$config.service.uploadApi}`,
                            type: 'POST',
                            data: formData,
                            miniType: 'multipart/form-data',
                            contentType: false,
                            processData: false,
                            success: await function(data) {
                                // console.log(data.key)
                                resolve(data.message)
                            },
                            error:()=> {
                                alert(this.$t('main.UploadFailed'));
                            }
                        })
                    })
                },
            }),
            new Blockquote(),
            new TextAlign(),
            new BulletList(),
            new OrderedList(),
            new TodoItem(),
            new TodoList(),
            new Indent(),
            new HardBreak(),
            new HorizontalRule(),
            new Fullscreen(),
            new History(),
            new ClearFormat(),
        ]
    },
    methods: {
        toEdit(){
            // console.log(sessionStorage.getItem('htmlEditor'))
            // console.log(this.htmlEditor)
            this.dialogVisible = true
        },
        onClick(e) {
            // console.log(this.editorContext)
            this.dialogVisible = false
            // console.log(this.htmlContent)
            // if(updateHtml)
            // {
            //     alert(212);
            // }
            this.$emit("click", this.htmlContent);
        },
        cancel() {
            this.dialogVisible = false
        },
    }
};
</script>

<style lang="scss" scoped>
.el-icon-edit-outline{
    font-weight: bold !important;
}
.advanced-editor{
    /deep/.el-dialog{
        width: 800px;
    }
}
</style>